import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { GtwDirectivesModule } from '../shared/_directives/gtw-directives.module';
import { ExternalLinkComponent } from './external-link/external-link.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppNgAppkitModule } from '../app-ng-appkit.module';

@NgModule({
  declarations: [HeaderComponent, ExternalLinkComponent],
  imports: [
    CommonModule,
    GtwDirectivesModule,
    DragDropModule,
    AppNgAppkitModule,
  ],
  exports: [HeaderComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class HeaderModule { }
